import type React from "react";
import { useTranslation } from "react-i18next";

import { Spinner } from "@krea/shared/design-system/Spinner";

import { BankIDAuthenticationState } from "../../components/BankIDAuthenticationState";

export const OAuthPendingFlow: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center">
      <Spinner className="mb-4" />
      <BankIDAuthenticationState className="mt-2 max-w-md text-center">
        {t("bankID.FI.authInProgressDescription")}
      </BankIDAuthenticationState>
    </div>
  );
};
